'use client';
import { Icon, List, Text } from '@/lib/mx-asurion-ui-react';

export const BenefitsUl = ({
  benefits,
  icon,
  footer,
}: {
  benefits: (string | null)[];
  icon?: string;
  footer?: string;
}) => {
  const listFooter = footer && (
    <Text size={1} weight="base">
      {footer}
    </Text>
  );

  return (
    <div className="pb-4 pt-2">
      <List as="ul" alignment="top">
        {benefits.map((item) =>
          item != null ? (
            <List.Item key={item} className="!bg-transparent">
              {icon && (
                <List.Item.Leading>
                  <Icon.SSR size="large" src={icon} />
                </List.Item.Leading>
              )}
              {item && (
                <List.Item.SupportiveText className="!text-sm !font-normal !text-[#1A1C1E]">
                  {item}
                </List.Item.SupportiveText>
              )}
            </List.Item>
          ) : null,
        )}
      </List>
      <span className="text-sm">{listFooter}</span>
    </div>
  );
};
